



















import mixins from 'vue-typed-mixins';
import OversightUtils, {
  OversightOrganization,
} from '../../utils/OversightUtils';
import cloneDeep from 'lodash.clonedeep';
import OversightForm from '@/components/oversight/OversightForm.vue';
export default mixins().extend({
  components: {
    OversightForm,
  },
  computed: {
    id(): number | undefined {
      const id = parseInt(this.$route.params.id);
      return !isNaN(id) ? id : undefined;
    },
  },
  data(): {
    oversight?: Partial<OversightOrganization>;
  } {
    return {
      oversight: {
        name: this.$languageobj(),
        state: 'active',
        oversighttype: undefined,
        parent: undefined,
      },
    };
  },
  methods: {
    async submit() {
      if (this.oversight) {
        try {
          this.$alert.hide('submit');
          await OversightUtils.api.instance.add(
            this.oversight as OversightOrganization
          );
          await this.$router.push({ name: 'oversight-list' });
          this.$toast.push({
            type: 'success',
            text: this.$languageobj('validation.success.add', {
              values: [this.oversight.name],
            }),
          });
        } catch (error) {
          this.$alert.show('submit', {
            type: 'error',
            messages: this.$handleAPIError(error, this.$refs.observer),
          });
        }
      }
    },
  },
});
